<template lang="">
      <l-icon
        :icon-anchor="iconAnchor"
        style="z-index:380"
      >
        <div
          class="marker-pin text-dark" style='opacity: 0.5;'
        >
            <i class='fa fa-crosshairs fa-3x'></i>
        </div>
      </l-icon>
</template>
<script>
import {LIcon } from "vue2-leaflet";

export default {
  components: {
    LIcon,
  },
  data() {
    return {
      iconAnchor: [17, 17],
    };
  },

};
</script>
<style lang="scss">

</style>